import { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TwitterShareButton, TwitterIcon } from 'react-share';
import { useDropzone } from 'react-dropzone';
import { Header } from './MonacottoMiscUI';
import {
  TextAreaAutoSize,
  TextLine3,
} from './UtilComponents';
import { useGlobalStateSelector, words } from './globalState';
import {
  handleClickSaveNote,
  getUserResource,
  getComponents,
} from './note';
import {
  isSessionValid,
} from './keysAndSigning';
import {
  useCallbackPrompt,
  jconfirm,
  urlParamsStringify,
  copyToClipboard,
  getContentTypeAndSuffix,
  devLog,
} from './utils';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconEdit from './edit_FILL0_wght400_GRAD0_opsz48.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconHome from './home_FILL0_wght400_GRAD0_opsz48.svg';
import iconShare from './share_FILL0_wght400_GRAD0_opsz48.svg';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconMenu from './menu_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';

// POPUP DISPLAY
function PopupDisplay(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const marginOfSessionTime = state.marginOfSessionTime;
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const note = props.note;
  const noteNo = note.noteNo;
  const index = props.index;
  const stateSetterForChange = props.stateSetterForChange;
  const addressMain = state.gallery.addressMain;

  // 公開・下書き区分

  let publicationType;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft') {
    publicationType = 'draft';
  }
  else {
    publicationType = 'published';
  }

  const popupDisplay = note[publicationType]?.popupDisplay;

  if (popupDisplay === undefined) {
    return null;
  }

  // アクセスモード

  let accessMode;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.accessMode === 'edit') {
    accessMode = 'edit';
  }
  else {
    // eslint-disable-next-line no-unused-vars
    accessMode = 'view';
  }

  // コンポーネント

  const components = popupDisplay.map( (component, indexComponent) => {
    if (component.resourceType === 'text') {
      return (
        <div className='marginTopBottom1 ' >
          <NoteText
            key={component.resourceId}
            addressMain={addressMain}
            noteNo={noteNo}
            publicationType={publicationType}
            componentContainerName='popupDisplay'
            accessMode='view'
            resourceId={component.resourceId}
            index={indexComponent}
          />
        </div>
      );
    }
    else if (component.resourceType === 'image') {
      return (
        <div className='marginTopBottom1 ' >
          <NoteImage
            key={component.resourceId}
            addressMain={addressMain}
            noteNo={noteNo}
            publicationType={publicationType}
            componentContainerName='popupDisplay'
            accessMode='view'
            resourceId={component.resourceId}
            index={indexComponent}
            url={component.url}
          />
        </div>
      );
    }
    else {
      return null;
    }
  });

  // 場所入替矢印

  const arrowLeft =
  <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large borderNone cursor borderRadiusCircle turnPink '
    onClick={ (e) => {
      if (
        state.editNote.maybeNotSaved[addressMain] === undefined ||
        Object.values(state.editNote.maybeNotSaved[addressMain]).includes(true) === false
      ) {
        e.stopPropagation();
        dispatch({ type: 'itemReplace', index: index, direction: 'left' });
        stateSetterForChange(true);
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseSaveYourDraftBeforeReplacing[state.language] });
      }
    }}
  >
    <img className='size2x2' src={iconCircleLeft} alt='' />
  </button>;

  const arrowRight =
  <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large borderNone cursor borderRadiusCircle turnPink '
    onClick={ (e) => {
      if (
        state.editNote.maybeNotSaved[addressMain] === undefined ||
        Object.values(state.editNote.maybeNotSaved[addressMain]).includes(true) === false
      ) {
        e.stopPropagation();
        dispatch({ type: 'itemReplace', index: index, direction: 'right' });
        stateSetterForChange(true);
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseSaveYourDraftBeforeReplacing[state.language] });
      }
    }}
  >
    <img className='size2x2' src={iconCircleRight} alt='' />
  </button>;

  // 編集ボタン

  const editButton =
  <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large borderNone cursor borderRadiusCircle turnPink '
    onClick={ (e) => {
      e.stopPropagation();

      const popup = {
        type: 'editPopupDisplayPopup',
        body: {
          addressMain: note.addressMain,
          noteNo: note.noteNo,
          publicationType: publicationType,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
    }}
  >
    <img className='size2x2' src={iconEdit} alt='' />
  </button>;

  // コントロールセクション

  let controlSection;

  if (
    state.screen === 'gallery' &&
    state.session[addressMain] !== undefined &&
    state.session[addressMain].expirationOfSession > Date.now() + marginOfSessionTime &&
    state.editNote.publicationType === 'draft'
  ) {
    controlSection =
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax ' >
      { arrowLeft }
      { editButton }
      { arrowRight }
    </div>;
  }


  return (
    <div className='flexColumn alignItemsCenter ' >
      { controlSection }
      <button className='boxCard justifyContentCenter ' disabled={props.disabled ? true : false}
        onClick={ () => {
          devLog('note', JSON.stringify(note, null, 2));
          devLog('notes', JSON.stringify(state.notes, null, 2));
          navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/note' : '/note', { state: { mode: 'update', addressMain: note.addressMain, noteNo: note.noteNo } });
        }}
      >
        { components }
      </button>
    </div>
  );
}

// EDIT POPUP DISPLAY POPUP
function EditPopupDisplayPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const addressMain = state.popup[popupLayer].body.addressMain;
  const noteNo = state.popup[popupLayer].body.noteNo;
  const publicationType = state.popup[popupLayer].body.publicationType;
  const noteTyped = state.notes[addressMain][noteNo][publicationType];
  const popupDisplay = noteTyped.popupDisplay;

  // コンポーネント

  const components = popupDisplay.map( (component, index) => {
    if (component.resourceType === 'text') {
      // コンポーネント管理ボタン

      const manageComponentButton =
      <button className='button2' tabIndex='0'
        onClick={ () => {
          const popup = {
            type: 'manageComponentPopup',
            body: {
              addressMain: addressMain,
              noteNo: noteNo,
              publicationType: publicationType,
              componentContainerName: 'popupDisplay',
              index: index,
              // resourceId: popupDisplay.resourceId,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconDetail} alt='' />
      </button>;

      return (
        <div className='flexColumn alignItemsFlexEnd marginTopBottom1 ' >
          <NoteText
            key={component.resourceId}
            addressMain={addressMain}
            noteNo={noteNo}
            publicationType={publicationType}
            componentContainerName='popupDisplay'
            accessMode='edit'
            resourceId={component.resourceId}
            index={index}
          />
          { manageComponentButton }
        </div>
      );
    }
    else if (component.resourceType === 'image') {
      // コンポーネント管理ボタン

      const manageComponentButton =
      <button className='button2' tabIndex='0'
        onClick={ () => {
          const popup = {
            type: 'manageComponentPopup',
            body: {
              addressMain: addressMain,
              noteNo: noteNo,
              publicationType: publicationType,
              componentContainerName: 'popupDisplay',
              index: index,
              // resourceId: component.resourceId,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconDetail} alt='' />
      </button>;

      return (
        <div className='flexColumn alignItemsFlexEnd marginTopBottom1 ' >
          <NoteImage
            key={component.resourceId}
            addressMain={addressMain}
            noteNo={noteNo}
            publicationType={publicationType}
            componentContainerName='popupDisplay'
            accessMode='edit'
            resourceId={component.resourceId}
            index={index}
            url={component.url}
          />
          <div className='marginTop0p5 ' >
            { manageComponentButton }
          </div>
        </div>
      );
    }
    else {
      return null;
    }
  });

  // // テキストコンポーネント追加ボタン

  // const addTextComponentButton =
  // <div className='flexRow justifyContentSpaceAround ' >
  //   <button className='button2' tabIndex='0'
  //     onClick={ () => {
  //       const resourceId = noteTyped.resourceIdMax + 1;
  //       const texts = noteTyped.texts;

  //       texts[resourceId] = {
  //         content: '',
  //         status: 'created',
  //         isNew: true,
  //       };

  //       popupDisplay.push({
  //         resourceId: resourceId,
  //         resourceType: 'text',
  //         width: state.config.clientParameters.note.popupDisplayWidthPc[0],
  //       });

  //       dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'popupDisplay'], value: popupDisplay });
  //       dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'resourceIdMax'], value: resourceId });
  //       dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'texts'], value: texts });
  //     }}
  //   >
  //     { 'text' }
  //   </button>
  // </div>;

  // // 保存ボタン
  // 
  // let saveButton;

  // if (true) {
  //   saveButton =
  //   <button className='button1' tabIndex='0'
  //     onClick={ () => {
  //       handleClickSaveNote(state, dispatch, 'update', addressMain, noteNo);
  //     }}
  //   >
  //     { 'save' }
  //   </button>;
  // }

  // ポップアップディスプレイメニュー

  let popupDisplayMenu;

  if (state.editNote.popupDisplayMenuStatus === 'neutral') {
    popupDisplayMenu =
    <div className='flexRow alignItemsCenter ' >
      <AddComponentButton addressMain={addressMain} keys={['editNote', 'popupDisplayMenuStatus']} />
      <SaveNoteButton addressMain={addressMain} noteNo={noteNo} />
    </div>;
  }
  else if (state.editNote.popupDisplayMenuStatus === 'resourceTypes') {
    popupDisplayMenu =
    <div className='flexRow alignItemsCenter ' >
      <AddTextButton addressMain={addressMain} noteNo={noteNo} publicationType={publicationType} componentContainerName='popupDisplay' />
      <AddImageButton addressMain={addressMain} noteNo={noteNo} publicationType={publicationType} componentContainerName='popupDisplay' />
      <CloseMenuButton keys={['editNote', 'popupDisplayMenuStatus']} />
    </div>;
  }


  return (
    <div className='flexColumn alignItemsCenter ' >
      { components }
      { popupDisplayMenu }
    </div>
  );
}

// NOTE
function Note(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const location = useLocation();
  // let mode = location.state.mode;
  let addressMain = location.state.addressMain;
  let noteNo = location.state.noteNo;
  const note = state.notes[addressMain]?.[noteNo];
  const authorName = state.usersGeneralIndex[addressMain]?.userName || '';
  const isNew = note?.updateTime === undefined ? true : false;

  useCallbackPrompt(state, dispatch, state.editNote.maybeNotSaved[addressMain]?.[noteNo], words.thisNoteHasNotBeenSavedAreYouSureYouWantToLeaveThisScreen[state.language], null);

  useEffect(() => {
    if (addressMain === undefined || noteNo === undefined || note === undefined) {
      navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/newcard' : '/newcard');
    }

    const func = async () => {
      if (isNew === false && state.editNote.loaded.components[addressMain]?.[noteNo] !== true) {
        // ユーザーリソース取得

        dispatch({ type: 'setState', key: 'accessing', value: true });

        const components = getComponents({
          note,
          componentContainer: 'components',
          session: state.session,
          marginOfSessionTime: state.marginOfSessionTime,
        });
        await getUserResource({
          dispatch,
          userResources: components,
          session: state.session,
          marginOfSessionTime: state.marginOfSessionTime,
        })
        .then(() => {
          const loadStatus = state.editNote.loaded.components[addressMain] || {};
          loadStatus[noteNo] = true;

          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'loaded', 'components', addressMain], value: loadStatus });
        })
        .catch((error) => {
        });

        dispatch({ type: 'setState', key: 'accessing', value: false });
      }
    };

    func();
  }, []);

  const shareUlrAreaRef = useRef(null);

  if (note === undefined) {
    return null;
  }

  // 公開・下書き区分

  let publicationType;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft') {
    publicationType = 'draft';
  }
  else {
    publicationType = 'published';
  }

  // アクセスモード

  let accessMode;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.accessMode === 'edit') {
    accessMode = 'edit';
  }
  else {
    accessMode = 'view';
  }

  // コンポーネント

  let components;

  if ( note[publicationType] !== undefined ) {
    components = note[publicationType].components.map( (component, index) => {
      if (component.resourceType === 'text') {
        // コンポーネント管理ボタン

        let manageComponentButton;

        if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft' && state.editNote.accessMode === 'edit') {
          manageComponentButton =
          <button className='button2' tabIndex='0'
            onClick={ () => {
              const popup = {
                type: 'manageComponentPopup',
                body: {
                  addressMain: addressMain,
                  noteNo: noteNo,
                  publicationType: publicationType,
                  componentContainerName: 'components',
                  index: index,
                  // resourceId: component.resourceId,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            }}
          >
            <img className='size2x2' src={iconDetail} alt='' />
          </button>;
        }

        return (
          <div className='flexColumn alignItemsFlexEnd marginTopBottom1 ' >
            <NoteText
              key={component.resourceId}
              addressMain={addressMain}
              noteNo={noteNo}
              publicationType={publicationType}
              componentContainerName='components'
              accessMode={accessMode}
              resourceId={component.resourceId}
              index={index}
              url={component.url}
            />
            <div className='marginTop0p5 ' >
              { manageComponentButton }
            </div>
          </div>
        );
      }
      else if (component.resourceType === 'image') {
        // コンポーネント管理ボタン

        let manageComponentButton;

        if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft' && state.editNote.accessMode === 'edit') {
          manageComponentButton =
          <button className='button2' tabIndex='0'
            onClick={ () => {
              const popup = {
                type: 'manageComponentPopup',
                body: {
                  addressMain: addressMain,
                  noteNo: noteNo,
                  publicationType: publicationType,
                  componentContainerName: 'components',
                  index: index,
                  // resourceId: component.resourceId,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            }}
          >
            <img className='size2x2' src={iconDetail} alt='' />
          </button>;
        }

        return (
          <div className='flexColumn alignItemsFlexEnd marginTopBottom1 ' >
            <NoteImage
              key={component.resourceId}
              addressMain={addressMain}
              noteNo={noteNo}
              publicationType={publicationType}
              componentContainerName='components'
              accessMode={accessMode}
              resourceId={component.resourceId}
              index={index}
              url={component.url}
            />
            <div className='marginTop0p5 ' >
              { manageComponentButton }
            </div>
          </div>
        );
      }
      else {
        return null;
      }
    });
  }

  // その他ボタン

  let othersButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft') {
    othersButton =
    <button className='button1' tabIndex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'rightMenuStatus'], value: 'others' });
      }}
    >
      <img className='size2x2' src={iconDetail} alt='' />
    </button>;
  }

  // 右側メニュー

  let rightMenu;

  if (state.editNote.rightMenuStatus === 'neutral') {
    rightMenu =
    <div className='flexRow alignItemsCenter ' >
      <AddComponentButton addressMain={addressMain} keys={['editNote', 'rightMenuStatus']} />
      <SaveNoteButton addressMain={addressMain} noteNo={noteNo} />
      <div>
        { othersButton }
      </div>
    </div>;
  }
  else if (state.editNote.rightMenuStatus === 'resourceTypes') {
    rightMenu =
    <div className='flexRow alignItemsCenter ' >
      <AddTextButton addressMain={addressMain} noteNo={noteNo} publicationType={publicationType} componentContainerName='components' />
      <AddImageButton addressMain={addressMain} noteNo={noteNo} publicationType={publicationType} componentContainerName='components' />
      <CloseMenuButton keys={['editNote', 'rightMenuStatus']} />
    </div>;
  }
  else if (state.editNote.rightMenuStatus === 'others') {
    rightMenu =
    <div className='flexRow alignItemsCenter ' >
      <div>
        <PublishNoteButton addressMain={addressMain} noteNo={noteNo} />
      </div>
      <div>
        <UnpublishNoteButton addressMain={addressMain} noteNo={noteNo} />
      </div>
      <div>
        <DeleteNoteButton addressMain={addressMain} noteNo={noteNo} popupLayer={popupLayer} />
      </div>
      <CloseMenuButton keys={['editNote', 'rightMenuStatus']} />
    </div>;
  }

  // ホームボタン

  const homeButton =
  <button className='button1' tabindex='0'
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['gallery', 'addressMain'], value: note.addressMain });
      navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home'); 
    }}
  >
    <img className='size2x2' src={iconHome} alt='' />
  </button>;

  // シェアボタン

  const shareButton =
  <button className='button1' tabindex='0'
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['viewNote', 'viewerMenuStatus'], value: 'share' });
    }}
  >
    <img className='size2x2' src={iconShare} alt='' />
  </button>;

  const urlParams = [`mainaddress=${note.addressMain}`, `noteno=${note.noteNo}`];

  if (state.language !== 'japanese') {
    urlParams.push(`language=${state.language}`);
  }

  const urlParamsStr = urlParamsStringify(urlParams);
  const url = `https://${process.env.REACT_APP_MONACOTTO_EXTENSION_URL}redirect${urlParamsStr}`;
  const title = `もなこっと ${authorName}のノートです。`
  const hashtags = ['monacotto', 'もなこっと'];

  const twitterButton =
  <TwitterShareButton
    url={url}
    title={title}
    hashtags={hashtags}
  >
    <TwitterIcon size={32} round />
  </TwitterShareButton>;

  const copyUrlButton =
  <div>
    <button className='button1 margin1' tabindex='0' 
      onClick={ () => {
        navigator.clipboard.writeText(url)
        .then()
        .catch( err => {
          copyToClipboard(url, shareUlrAreaRef);
        });
      }}
    >
      <img className='size2x2' src={iconCopy} alt='copy' />
    </button>
    <textarea ref={shareUlrAreaRef} style={{ position: 'absolute', left: '-9999px' }} ></textarea>
  </div>;

  // キャンセルボタン

  const viewerMenuCancelButton =
  <button className='button1' tabIndex='0'
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['viewNote', 'viewerMenuStatus'], value: 'neutral' });
    }}
  >
    { '×' }
  </button>;

  // ビューワメニュー

  let viewerMenu;

  if (accessMode === 'view' || publicationType === 'published') {
    if (state.viewNote.viewerMenuStatus === 'neutral') {
      viewerMenu =
      <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax ' >
        { shareButton }
        { homeButton }
      </div>;
    }
    else if (state.viewNote.viewerMenuStatus === 'share') {
      viewerMenu =
      <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax ' >
        { twitterButton }
        { copyUrlButton }
        { viewerMenuCancelButton }
      </div>;
    }
  }

  // ノートヘッダ

  let headerFixed;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime })) {
    headerFixed =
    <div className='flexRow justifyContentSpaceBetween marginBottom1' >
      <div className='flexRow ' >
        <div>
          <ChangePublicationTypeButton addressMain={addressMain} />
        </div>
        <div>
          <ChangeAccessModeButton addressMain={addressMain} />
        </div>
      </div>
      <div>
        { rightMenu }
      </div>
    </div>;
  }

  const headerRelative =
  <div className='widthMax ' style={{ height: state.editNote.headerHeight }} >
  </div>;

  // SP用メニューボタン

  let menuButtonSp;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime })) {
    menuButtonSp =
    <button className='button1 size48px48px backgroundColorPinkPaleBf z200FixedRightBottom ' tabIndex='0'
      onClick={ () => {
        const popup = {
          type: 'noteMenuSpPopup',
          body: {
            addressMain: addressMain,
            noteNo: noteNo,
            publicationType: publicationType,
            componentContainerName: 'components',
          },
        };

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
        <img className='size2x2' src={iconMenu} alt='menu' />
    </button>;
  }

  // SP用ボトムアップ

  const bottomUpSp =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div className='' >
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter ">
        <Header screen='note' noteInfo={{ addressMain, noteNo, screen: 'note' }} headerAdditional={headerFixed} headerClass='z200FixedZero width99P5vw ' heightObservation={true} />
        <div className='relative width98vw flexColumn alignItemsCenter ' >
          { headerRelative }
          { viewerMenu }
          { components }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <Header screen='note' noteInfo={{ addressMain, noteNo, screen: 'note' }} />
        <div className='relative width98vw flexColumn alignItemsCenter ' >
          { viewerMenu }
          { components }
          { bottomUpSp }
        </div>
        { menuButtonSp }
      </div>
    </div>
  );
}

// コンポーネント追加ボタン
// ADD COMPONENT BUTTON
function AddComponentButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const keys = props.keys;

  let addComponentButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft' && state.editNote.accessMode === 'edit') {
    addComponentButton =
    <button className='button2' tabIndex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: keys, value: 'resourceTypes' });
      }}
    >
      { '＋' }
    </button>;
  }


  return addComponentButton;
}

// クローズメニューボタン
// CLOSE MENU BUTTON
function CloseMenuButton(props) {
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const keys = props.keys;

  const closeMenuButton =
  <button className='button1' tabIndex='0'
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: keys, value: 'neutral' });
    }}
  >
    { '×' }
  </button>;


  return closeMenuButton;
}

// テキスト追加ボタン
// ADD TEXT BUTTON
function AddTextButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;
  const publicationType = props.publicationType;
  const componentContainerName = props.componentContainerName;
  const noteTyped = state.notes[addressMain][noteNo][publicationType];
  const initialWidth = {
    components: state.config.clientParameters.note.textWidthPc[0].width,
    popupDisplay: state.config.clientParameters.note.textWidthPopupDisplayPc[0].width,
  };

  let textButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft' && state.editNote.accessMode === 'edit') {
    textButton =
    <button className='button2' tabIndex='0'
      onClick={ () => {
        const componentContainer = noteTyped[componentContainerName];
        const resourceId = noteTyped.resourceIdMax + 1;
        const texts = noteTyped.texts;

        texts[resourceId] = {
          content: '',
          status: 'created',
          isNew: true,
        };

        componentContainer.push({
          resourceId: resourceId,
          resourceType: 'text',
          width: initialWidth[componentContainerName],
          fontSize: state.config.clientParameters.note.fontSize[state.config.clientParameters.note.fontSize.length - 1],
          textPosition: 'left',
        });

        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, componentContainerName], value: componentContainer });
        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'resourceIdMax'], value: resourceId });
        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'texts'], value: texts });
        // dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'rightMenuStatus'], value: 'neutral' });

        if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
          let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

          if (maybeNotSaved === undefined) {
            maybeNotSaved = {};
          }

          maybeNotSaved[noteNo] = true;

          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
        }
      }}
    >
      { words.text[state.language] }
    </button>;
  }


  return textButton;
}

// 画像追加ボタン
// ADD IMAGE BUTTON
function AddImageButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;
  const publicationType = props.publicationType;
  const componentContainerName = props.componentContainerName;
  const noteTyped = state.notes[addressMain][noteNo][publicationType];
  const initialWidth = {
    components: state.config.clientParameters.note.imageWidthPc[0].width,
    popupDisplay: state.config.clientParameters.note.imageWidthPopupDisplayPc[0].width,
  };

  let imageButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft' && state.editNote.accessMode === 'edit') {
    imageButton =
    <button className='button2' tabIndex='0'
      onClick={ () => {
        const componentContainer = noteTyped[componentContainerName];
        const resourceId = noteTyped.resourceIdMax + 1;
        const images = noteTyped.images;

        images[resourceId] = {
          content: '', // <-?
          isNew: true,
        };

        componentContainer.push({
          resourceId: resourceId,
          resourceType: 'image',
          width: initialWidth[componentContainerName],
        });

        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, componentContainerName], value: componentContainer });
        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'resourceIdMax'], value: resourceId });
        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images'], value: images });

        if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
          let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

          if (maybeNotSaved === undefined) {
            maybeNotSaved = {};
          }

          maybeNotSaved[noteNo] = true;

          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
        }
      }}
    >
      { words.image[state.language] }
    </button>;
  }


  return imageButton;
}

// ノート保存ボタン
// SAVE NOTE BUTTON
function SaveNoteButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;
  const note = state.notes[addressMain][noteNo];
  const isNew = note.updateTime === undefined ? true : false;
  
  let saveButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft') {
    saveButton =
    <button className='button2' tabIndex='0'
      onClick={ () => {
        const mode = isNew === true ? 'insert' : 'update';
        handleClickSaveNote(state, dispatch, mode, addressMain, noteNo);
      }}
    >
      { words.saveDraft[state.language] }
    </button>;
  }


  return saveButton;
}

// 公開ボタン
// PUBLISH NOTE BUTTON
function PublishNoteButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;

  let publishButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft') {
    publishButton =
    <button className='button2' tabIndex='0'
      onClick={ () => {
        if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
          handleClickSaveNote(state, dispatch, 'publish', addressMain, noteNo);
        }
        else {
          dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseSaveYourDraftBeforePublishing[state.language] });
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'rightMenuStatus'], value: 'neutral' });
      }}
    >
      { words.publish[state.language] }
    </button>;
  }

  return publishButton;
}

// 非公開ボタン
// UNPUBLISH NOTE BUTTON
function UnpublishNoteButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;

  let unpublishButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime })) {
    unpublishButton =
    <button className='button2 textCenter ' tabIndex='0'
      onClick={ () => {
        handleClickSaveNote(state, dispatch, 'unpublish', addressMain, noteNo);
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'rightMenuStatus'], value: 'neutral' });
      }}
    >
      <div>
        { words.unpublish1[state.language] }<br />
        { words.unpublish2[state.language] }<br />
      </div>
    </button>;
  }

  return unpublishButton;
}

// 削除ボタン
// DELETE NOTE BUTTON
function DeleteNoteButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;
  const popupLayer = props.popupLayer;

  let deleteButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime })) {
    deleteButton =
    <button className='button2' tabIndex='0'
      onClick={ () => {
        const word = words.areYouSureYouWillDeleteThisNote[state.language];
        const options = [
          {
            face: 'OK',
            onClickFunction: async () => {
              // awaitしないと、galleryに戻ったときに、古いnote, itemPlacementが取得されてしまう。（本当は、手動でgalleryに戻ったときも考慮に入れたほうがよい。）
              await handleClickSaveNote(state, dispatch, 'delete', addressMain, noteNo);
              navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/home' : '/home');
            },
          },
          {
            face: 'Cancel',
          },
        ];

        jconfirm(state, dispatch, popupLayer, word, options);
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'rightMenuStatus'], value: 'neutral' });
      }}
    >
      { words.delete[state.language] }
    </button>;
  }

  return deleteButton;
}

// publicationType変更ボタン
// CHANGE PUBLICATION TYPE BUTTON
function ChangePublicationTypeButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const publicationType = state.editNote.publicationType;

  let changePublicationTypeButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime })) {
    changePublicationTypeButton =
    <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2' tabindex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'publicationType'], value: publicationType === 'draft' ? 'published' : 'draft' });
      }}
    >
      { words[publicationType][state.language] }
    </button>;
  }


  return changePublicationTypeButton;
}

// accessMode変更ボタン
// CHANGE ACCESS MODE BUTTON
function ChangeAccessModeButton(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const accessMode = state.editNote.accessMode;

  let changeAccessModeButton;

  if (isSessionValid({ address: addressMain, session: state.session, marginOfSessionTime: state.marginOfSessionTime }) && state.editNote.publicationType === 'draft') {
    changeAccessModeButton =
    <button className='height3 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginTop1 marginSide0p2' tabindex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'accessMode'], value: accessMode === 'edit' ? 'view' : 'edit' });
      }}
    >
      { words[accessMode + 'Mode'][state.language] }
    </button>;
  }

  return changeAccessModeButton;
}

// SP用ノートメニューPOPUP
// NOTE MENU SP POPUP
function NoteMenuSpPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const popupLayer = props.popupLayer;
  const popup = state.popup[popupLayer];
  const addressMain = popup.body.addressMain;
  const noteNo = popup.body.noteNo;
  const publicationType = popup.body.publicationType;
  const componentContainerName = popup.body.componentContainerName;

  return (
    <div className='flexColumn alignItemsCenter ' >
      <div className='flexRow alignItemsCenter marginTopBottom0p5 ' >
        <ChangePublicationTypeButton addressMain={addressMain} />
        <ChangeAccessModeButton addressMain={addressMain} />
      </div>
      <div className='flexRow alignItemsCenter marginTopBottom0p5 ' >
        <AddTextButton addressMain={addressMain} noteNo={noteNo} publicationType={publicationType} componentContainerName={componentContainerName} />
        <AddImageButton addressMain={addressMain} noteNo={noteNo} publicationType={publicationType} componentContainerName={componentContainerName} />
        <SaveNoteButton addressMain={addressMain} noteNo={noteNo} />
      </div>
      <div className='flexRow alignItemsCenter marginTopBottom0p5 ' >
        <PublishNoteButton addressMain={addressMain} noteNo={noteNo} />
        <UnpublishNoteButton addressMain={addressMain} noteNo={noteNo} />
        <DeleteNoteButton addressMain={addressMain} noteNo={noteNo} popupLayer={popupLayer} />
      </div>
    </div>
  );
}

// // ADD COMPONENT POPUP
// function AddComponentPopup(props) {
//   const {state, dispatch} = useContext(GlobalState);
//   const popupLayer = props.popupLayer;
//   const popup = state.popup[popupLayer];
//   const addressMain = popup.body.addressMain;
//   const noteNo = popup.body.noteNo;
//   const publicationType = popup.body.publicationType;
//   const noteTyped = state.notes[addressMain][noteNo][publicationType];
// 
//   // コンポーネント選択ボタン
// 
//   const selectComponentButtons =
//   <div className='flexRow justifyContentSpaceAround ' >
//     <button className='button2' tabIndex='0'
//       onClick={ () => {
//         const components = noteTyped.components;
//         const resourceId = noteTyped.resourceIdMax + 1;
//         const texts = noteTyped.texts;
// 
//         texts[resourceId] = {
//           content: '',
//           status: 'created',
//           isNew: true,
//         };
// 
//         components.push({
//           resourceId: resourceId,
//           resourceType: 'text',
//           width: state.config.clientParameters.note.textWidthPc[0],
//         });
// 
//         dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'components'], value: components });
//         dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'resourceIdMax'], value: resourceId });
//         dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'texts'], value: texts });
//       }}
//     >
//       { 'text' }
//     </button>
//     <button className='button2' tabIndex='0'
//       onClick={ () => {
//         const components = noteTyped.components;
//         const resourceId = noteTyped.resourceIdMax + 1;
//         const images = noteTyped.images;
// 
//         images[resourceId] = {
//           content: '', // <-?
//           isNew: true,
//         };
// 
//         components.push({
//           resourceId: resourceId,
//           resourceType: 'image',
//           width: state.config.clientParameters.note.imageWidthPc[0],
//         });
// 
//         dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'components'], value: components });
//         dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'resourceIdMax'], value: resourceId });
//         dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images'], value: images });
//       }}
//     >
//       { 'image' }
//     </button>
//   </div>;
// 
// 
//   return (
//     <div>
//      { selectComponentButtons }
//     </div>
//   );
// }

// NOTE TEXT
function NoteText(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;
  const publicationType = props.publicationType;
  const componentContainerName = props.componentContainerName;
  const componentContainer = state.notes[addressMain][noteNo][publicationType][componentContainerName];
  const accessMode = props.accessMode;
  const resourceId = props.resourceId;
  const index = props.index;
  const component = componentContainer[index];
  const fontSize = component.fontSize;
  const textPosition = component.textPosition;
  const url = props.url;

  // 整形

  let textFormattedFnc = () => null;
  const textBoxStylePc = {};
  const textBoxStyleSp = {};

  if (state.notes[addressMain][noteNo][publicationType].texts[resourceId] !== undefined && state.config.clientParameters.note !== undefined) {
    textBoxStylePc.components = {
      width: ( state.config.clientParameters.note.widthPc * state.notes[addressMain][noteNo][publicationType][componentContainerName][index].width ) + 'px',
      fontSize: fontSize,
      textAlign: textPosition,
    };

    textBoxStylePc.popupDisplay = {
      width: ( state.config.clientParameters.note.widthPopupDisplayPc * state.notes[addressMain][noteNo][publicationType][componentContainerName][index].width ) + 'px',
      fontSize: fontSize,
      textAlign: textPosition,
    };

    textBoxStyleSp.components = {
      width: ( state.notes[addressMain][noteNo][publicationType][componentContainerName][index].width * 98 ) + 'vw',
      fontSize: fontSize,
      textAlign: textPosition,
    };

    textBoxStyleSp.popupDisplay = {
      width: ( state.config.clientParameters.note.widthPopupDisplaySp * state.notes[addressMain][noteNo][publicationType][componentContainerName][index].width ) + 'px',
      fontSize: fontSize,
      textAlign: textPosition,
    };

    if (publicationType === 'draft' && accessMode === 'edit') {
      textFormattedFnc = (textBoxStyle) =>
      <TextAreaAutoSize fieldName={'noteTextText' + resourceId} keys={['notes', addressMain, noteNo, publicationType, 'texts', resourceId, 'content']}
        textAreaClass='boxNoteText ' textAreaStyle={textBoxStyle} minRows={1}
        extraFunctionsOnChange={[
          {
            function: () => {
              if (state.notes[addressMain][noteNo][publicationType].texts[resourceId].status === undefined) {
                let status;

                if ( state.notes[addressMain][noteNo][publicationType].texts[resourceId].isNew === true) {
                  status = 'created';
                }
                else {
                  status = 'updated';
                }

                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['notes', addressMain, noteNo, publicationType, 'texts', resourceId, 'status'],
                  value: status,
                });
              }
            },
            arguments: [],
          },
          {
            function: () => {
              if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
                let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

                if (maybeNotSaved === undefined) {
                  maybeNotSaved = {};
                }

                maybeNotSaved[noteNo] = true;

                dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
              }
            },
            arguments: [],
          },
        ]}
      />;
    }
    else if (
      publicationType === 'published' ||
      (publicationType === 'draft' && accessMode === 'view')
    ) {
      textFormattedFnc = (textBoxStyle) =>
      <button className={'backgroundColorTransparent borderNone textLeft preWrap ' + (url !== undefined && url !== null  && url !== '' ? 'cursor' : '')} style={textBoxStyle} tabIndex='0'
        onClick={ () => {
          if (url !== undefined && url !== null && url !== '') {
            window.open(url, '_blank');
          }
        }}
      >
        { state.notes[addressMain][noteNo][publicationType].texts[resourceId].content }
      </button>;
    }
  }


  return (
    <div className='' >
      {/* PC */}
      <div className="visibleMiddleOrMore">
        { textFormattedFnc(textBoxStylePc[componentContainerName]) }
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        { textFormattedFnc(textBoxStyleSp[componentContainerName]) }
      </div>
    </div>
  );
}

// NOTE IMAGE
function NoteImage(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const addressMain = props.addressMain;
  const noteNo = props.noteNo;
  const publicationType = props.publicationType;
  const componentContainerName = props.componentContainerName;
  const componentContainer = state.notes[addressMain][noteNo][publicationType][componentContainerName];
  const accessMode = props.accessMode;
  const resourceId = props.resourceId;
  const index = props.index;
  const component = componentContainer[index];
  const url = props.url;
  const [dimensions, setDimensions] = useState({
    naturalWidth: state.config.clientParameters.note?.widthPc || 1,
    naturalHeight: (state.config.clientParameters.note?.widthPc || 1) * (state.config.clientParameters.note?.imageRatio || 0.5),
  });

  const onDropAccepted = useCallback( async (acceptedFiles) => {
    const acceptedFile = acceptedFiles[0];

    if (acceptedFile.size > state.config.clientParameters.uploadMaxBytes) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.fileSizeIsTooLarge[state.language] });
      return;
    }

    // 再レンダリングが発生する前に、ユーザーが連続してファイルをドロップした場合でも、確実に1個目のファイルのオブジェクトURLをrevokeする。
    if (state.notes[addressMain][noteNo][publicationType].images[resourceId].url?.startsWith('blob:')) {
      URL.revokeObjectURL(state.notes[addressMain][noteNo][publicationType].images[resourceId].url);
    }

    const objectUrl = URL.createObjectURL(acceptedFile);

    let status;

    if (state.notes[addressMain][noteNo][publicationType].images[resourceId].isNew === true) {
      // status = 'created';
      status = 'createdDirectUpload';
    }
    else {
      // status = 'updated';
      status = 'updatedDirectUpload';
    }

    const { contentType, suffix } = await getContentTypeAndSuffix(acceptedFile);

    dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images', resourceId, 'data'], value: acceptedFile });
    dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images', resourceId, 'url'], value: objectUrl });
    dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images', resourceId, 'status'], value: status });
    dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images', resourceId, 'contentType'], value: contentType });
    dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, 'images', resourceId, 'suffix'], value: suffix });

    if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
      let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

      if (maybeNotSaved === undefined) {
        maybeNotSaved = {};
      }

      maybeNotSaved[noteNo] = true;

      dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
    }
  }, [state.notes[addressMain][noteNo][publicationType].images[resourceId]?.url]);

  // コンポーネントアンマウント時や url 変更時のクリーンナップ
  useEffect(() => {
    return () => {
      if (state.notes[addressMain][noteNo][publicationType].images[resourceId]?.url?.startsWith('blob:')) {
        URL.revokeObjectURL(state.notes[addressMain][noteNo][publicationType].images[resourceId].url);
      }
    };
  }, []);

  // imageCore の onLoad ハンドラーでサイズを取得
  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setDimensions({ naturalWidth, naturalHeight });
    console.log("Natural Width:", naturalWidth, "Natural Height:", naturalHeight);
  };

  const maxFiles = 1;
  const accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/gif': ['.gif'],
  };

  // eslint-disable-next-line no-unused-vars
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({ onDropAccepted, maxFiles, accept });

  const imageCoreFnc = (imageCoreStyle) => {
    let imageCore;

    if (
      state.notes[addressMain][noteNo][publicationType].images[resourceId]?.url !== undefined &&
      state.notes[addressMain][noteNo][publicationType].images[resourceId]?.url !== null
    ) {
      imageCore = <img className='absoluteZero zM10 ' style={ imageCoreStyle } src={state.notes[addressMain][noteNo][publicationType].images[resourceId].url} onLoad={handleImageLoad} alt='' />
    }

    return imageCore;
  };

  // 整形

  let imageFormattedFnc = () => null;

  if (state.notes[addressMain][noteNo][publicationType].images[resourceId] !== undefined && state.config.clientParameters.note !== undefined) {
    const ratio = dimensions.naturalHeight / dimensions.naturalWidth;

    const imageWidth = {
      pc: {
        components: (state.config.clientParameters.note.widthPc * component.width) + 'px',
        popupDisplay: (state.config.clientParameters.note.widthPopupDisplayPc * component.width) + 'px',
      },
      sp: {
        components: (state.notes[addressMain][noteNo][publicationType][componentContainerName][index].width * 98) + 'vw',
        popupDisplay: (state.config.clientParameters.note.widthPopupDisplaySp * component.width) + 'px',
      },
    }

    const imageHeight = {
      pc: {
        components: (state.config.clientParameters.note.widthPc * component.width * ratio) + 'px',
        popupDisplay: (state.config.clientParameters.note.widthPopupDisplayPc * component.width * ratio) + 'px',
      },
      sp: {
        components: (state.notes[addressMain][noteNo][publicationType][componentContainerName][index].width * 98 * ratio) + 'vw',
        popupDisplay: (state.config.clientParameters.note.widthPopupDisplaySp * component.width * ratio) + 'px',
      },
    }

    if (publicationType === 'draft' && accessMode === 'edit') {
      imageFormattedFnc = (device) => {
        const width = imageWidth[device][componentContainerName];
        const height = imageHeight[device][componentContainerName];

        const dropZoneStyle = {
          width: width,
          height: height,
          border: "1px dotted #888",
          boxSizing: 'border-box',
        };

        let imageCoreStyle = {
          width: width,
          height: height,
          objectFit: 'contain',
        };

        return (
          <div className='relative marginTopBottom1 '>
            <div {...getRootProps()} style={dropZoneStyle}>
              <input {...getInputProps()} style={{ display: 'none' }} />
            </div>
            { imageCoreFnc(imageCoreStyle) }
          </div>
        );
      };
    }
    else if (
      publicationType === 'published' ||
      ( publicationType === 'draft' && accessMode === 'view' )
    ) {
      imageFormattedFnc = (device) => {
        const width = imageWidth[device][componentContainerName];
        const height = imageHeight[device][componentContainerName];

        const imageContainerPublishedStyle = {
          width: width,
          height: height,
        };

        let imageCoreStyle = {
          width: width,
          height: height,
          objectFit: 'contain',
        };

        return (
          <div className='relative marginTopBottom1 '>
            <button className={'backgroundColorTransparent borderNone ' + (url !== undefined && url !== null  && url !== '' ? 'cursor' : '')} style={imageContainerPublishedStyle} tabIndex='0'
              onClick={ () => {
                if (url !== undefined && url !== null && url !== '') {
                  window.open(url, '_blank');
                }
              }}
            >
              { imageCoreFnc(imageCoreStyle) }
            </button>
          </div>
        );
      };
    }
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        { imageFormattedFnc('pc') }
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        { imageFormattedFnc('sp') }
      </div>
    </div>
  );
}

// MANAGE COMPONENT POPUP
function ManageComponentPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;
  const popup = state.popup[popupLayer];
  const addressMain = popup.body.addressMain;
  const noteNo = popup.body.noteNo;
  const publicationType = popup.body.publicationType;
  const noteTyped = state.notes[addressMain][noteNo][publicationType];
  const componentContainerName = popup.body.componentContainerName;
  const componentContainer = noteTyped[componentContainerName];
  const indexInitial = popup.body.index;
  const [indexCurrent, setIndexCurrent] = useState(indexInitial);
  const [fontSizeMenuStatus, setFontSizeMenuStatus] = useState('neutral');
  const [widthMenuStatus, setWidthMenuStatus] = useState('neutral');
  const [textPositionMenuStatus, setTextPositionMenuStatus] = useState('neutral');
  const resourceType = componentContainer[indexCurrent].resourceType;
  const resourceId = componentContainer[indexCurrent].resourceId;
  const resourceContainerName = {
    text: 'texts',
    image: 'images',
  };

  // 削除ボタン

  const deleteButton =
  <div className='flexRow justifyContentSpaceAround ' >
    <button className='button2' tabIndex='0'
      onClick={ () => {
        const resourceContainer = noteTyped[resourceContainerName[componentContainer[indexCurrent].resourceType]];
        const resource = resourceContainer[resourceId];

        if (resource.isNew === true) {
          delete resourceContainer[resourceId];
          dispatch({
            type: 'setStateMultiLayers',
            keys: ['notes', addressMain, noteNo, publicationType, resourceContainerName[componentContainer[indexCurrent].resourceType]],
            value: resourceContainer
          });
        }
        else {
          resource.status = 'deleted';
          resource.suffix = componentContainer[indexCurrent].suffix;
          resource.timestamp = componentContainer[indexCurrent].timestamp;
          dispatch({
            type: 'setStateMultiLayers',
            keys: ['notes', addressMain, noteNo, publicationType, resourceContainerName[componentContainer[indexCurrent].resourceType], resourceId],
            value: resource
          });
        }

        componentContainer.splice(indexCurrent, 1);
        dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, componentContainerName], value: componentContainer });

        if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
          let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

          if (maybeNotSaved === undefined) {
            maybeNotSaved = {};
          }

          maybeNotSaved[noteNo] = true;

          dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
      }}
    >
      { words.delete[state.language] }
    </button>
  </div>;

  // 移動ボタン

  const upButton =
  <div className='flexRow justifyContentSpaceAround ' >
    <button className='button2' tabIndex='0'
      onClick={ () => {
        if (indexCurrent !== 0) {
          const tmp = componentContainer[indexCurrent];
          componentContainer[indexCurrent] = componentContainer[indexCurrent - 1];
          componentContainer[indexCurrent - 1] = tmp;
          setIndexCurrent(indexCurrent - 1);

          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, componentContainerName], value: componentContainer });

          if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
            let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

            if (maybeNotSaved === undefined) {
              maybeNotSaved = {};
            }

            maybeNotSaved[noteNo] = true;

            dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
          }
        }
      }}
    >
      { 'UP⇧' }
    </button>
  </div>;

  const downButton =
  <div className='flexRow justifyContentSpaceAround ' >
    <button className='button2' tabIndex='0'
      onClick={ () => {
        if (indexCurrent !== componentContainer.length - 1) {
          const tmp = componentContainer[indexCurrent];
          componentContainer[indexCurrent] = componentContainer[indexCurrent + 1];
          componentContainer[indexCurrent + 1] = tmp;
          setIndexCurrent(indexCurrent + 1);

          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, componentContainerName], value: componentContainer });

          if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
            let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

            if (maybeNotSaved === undefined) {
              maybeNotSaved = {};
            }

            maybeNotSaved[noteNo] = true;

            dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
          }
        }
      }}
    >
      { 'DOWN⇩' }
    </button>
  </div>;

  // 幅

  // 幅メニューボタン

  const widthMenuButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
    onClick={ () => {
      setWidthMenuStatus('widths');
    }}
  >
    { words.width[state.language] }
  </button>;

  // 幅ボタン

  let widthOptions;

  if (componentContainerName === 'components') {
    if (resourceType === 'text') {
      widthOptions = state.config.clientParameters.note.textWidthPc;
    }
    else if (resourceType === 'image') {
      widthOptions = state.config.clientParameters.note.imageWidthPc;
    }
  }
  else if (componentContainerName === 'popupDisplay') {
    if (resourceType === 'text') {
      widthOptions = state.config.clientParameters.note.textWidthPopupDisplayPc;
    }
    else if (resourceType === 'image') {
      widthOptions = state.config.clientParameters.note.imageWidthPopupDisplayPc;
    }
  }

  const widthButtons = widthOptions.map( widthInfo => {
    return (
      <button className='button2' tabIndex='0'
        onClick={ () => {
          dispatch({
            type: 'setStateMultiLayers',
            keys: ['notes', addressMain, noteNo, publicationType, componentContainerName, indexCurrent, 'width'],
            value: widthInfo.width,
          });

          if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
            let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

            if (maybeNotSaved === undefined) {
              maybeNotSaved = {};
            }

            maybeNotSaved[noteNo] = true;

            dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
          }
        }}
      >
        { words[widthInfo.face][state.language] }
      </button>
    );
  });

  // キャンセルボタン

  const widthCancelButton =
  <button className='button1' tabIndex='0'
    onClick={ () => {
      setWidthMenuStatus('neutral');
    }}
  >
    { '×' }
  </button>;

  // 幅メニュー

  let widthMenu;

  if (widthMenuStatus === 'neutral') {
    widthMenu =
    <div className='flexRow alignItemsCenter ' >
      <div>
        { widthMenuButton }
      </div>
    </div>;
  }
  else if (widthMenuStatus === 'widths') {
    widthMenu =
    <div className='flexRow alignItemsCenter ' >
      { widthButtons }
      <div>
        { widthCancelButton }
      </div>
    </div>;
  }

  // const imageWidthOption = [
  //   { value: state.config.clientParameters.note.imageWidthPc[0], label: words.large[state.language] },
  //   { value: state.config.clientParameters.note.imageWidthPc[1], label: words.middle[state.language] },
  // ];

  // const assetTypeDropdown =
  // <select className="custom-dropdown" value={noteTyped[resourceContainerName[components[indexCurrent].resourceType]][resourceId].width}
  //   onChange={ event => {
  //     dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'assetType'], value: event.target.value });
  //   }}
  // >
  //   {
  //     imageWidthOption.map( option => (
  //       <option key={option.value} value={option.value}>
  //         {option.label}
  //       </option>
  //     ))
  //   }
  // </select>

  // フォントサイズ

  // フォントサイズメニューボタン

  const fontSizeMenuButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
    onClick={ () => {
      setFontSizeMenuStatus('fontSizes');
    }}
  >
    { words.fontSize[state.language] }
  </button>;

  // サイズボタン

  const fontSizeButtons = state.config.clientParameters.note.fontSize.map( size => {
    return (
      <button className='button1' tabIndex='0'
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['notes', addressMain, noteNo, publicationType, componentContainerName, indexCurrent, 'fontSize'], value: size });
          // setFontSizeMenuStatus('neutral');

          if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
            let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

            if (maybeNotSaved === undefined) {
              maybeNotSaved = {};
            }

            maybeNotSaved[noteNo] = true;

            dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
          }
        }}
      >
        { size }
      </button>
    );
  });

  // キャンセルボタン

  const cancelButton =
  <button className='button1' tabIndex='0'
    onClick={ () => {
      setFontSizeMenuStatus('neutral');
    }}
  >
    { '×' }
  </button>;

  // フォントサイズメニュー

  let fontSizeMenu;

  if (resourceType === 'text') {
    if (fontSizeMenuStatus === 'neutral') {
      fontSizeMenu =
      <div className='flexRow alignItemsCenter ' >
        <div>
          { fontSizeMenuButton }
        </div>
      </div>;
    }
    else if (fontSizeMenuStatus === 'fontSizes') {
      fontSizeMenu =
      <div className='flexRow alignItemsCenter ' >
        { fontSizeButtons }
        <div>
          { cancelButton }
        </div>
      </div>;
    }
  }

  // 文字位置

  // 文字位置メニューボタン

  const textPositionMenuButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
    onClick={ () => {
      setTextPositionMenuStatus('textPositions');
    }}
  >
    { words.textPosition[state.language] }
  </button>;

  // 文字位置ボタン

  const textPositionButtons = state.config.clientParameters.note.textPosition.map( position => {
    return (
      <button className='button2' tabIndex='0'
        onClick={ () => {
          dispatch({
            type: 'setStateMultiLayers',
            keys: ['notes', addressMain, noteNo, publicationType, componentContainerName, indexCurrent, 'textPosition'],
            value: position.value,
          });

          if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
            let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

            if (maybeNotSaved === undefined) {
              maybeNotSaved = {};
            }

            maybeNotSaved[noteNo] = true;

            dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
          }
        }}
      >
        { words[position.face][state.language] }
      </button>
    );
  });

  // キャンセルボタン

  const textPositionCancelButton =
  <button className='button1' tabIndex='0'
    onClick={ () => {
      setTextPositionMenuStatus('neutral');
    }}
  >
    { '×' }
  </button>;

  // 文字位置メニュー

  let textPositionMenu;

  if (resourceType === 'text') {
    if (textPositionMenuStatus === 'neutral') {
      textPositionMenu =
      <div className='flexRow alignItemsCenter ' >
        <div>
          { textPositionMenuButton }
        </div>
      </div>;
    }
    else if (textPositionMenuStatus === 'textPositions') {
      textPositionMenu =
      <div className='flexRow alignItemsCenter ' >
        { textPositionButtons }
        <div>
          { textPositionCancelButton }
        </div>
      </div>;
    }
  }

  // URLフィールド

  let urlField;

  if (componentContainerName === 'components') {
    urlField =
    <TextLine3 fieldName='manageComponentUrl' keys={['notes', addressMain, noteNo, publicationType, componentContainerName, indexCurrent, 'url']} face='URL' tooltip={false}
      extraFunctionOnChange={[
        {
          function: () => {
            if (state.editNote.maybeNotSaved[addressMain]?.[noteNo] !== true) {
              let maybeNotSaved = state.editNote.maybeNotSaved[addressMain];

              if (maybeNotSaved === undefined) {
                maybeNotSaved = {};
              }

              maybeNotSaved[noteNo] = true;

              dispatch({ type: 'setStateMultiLayers', keys: ['editNote', 'maybeNotSaved', addressMain], value: maybeNotSaved });
            }
          },
          arguments: [],
        }
      ]}
    />
  }


  return (
    <div className='flexColumn alignItemsCenter ' >
      <div className='flexColumn alignItemsFlexStart ' >
        <div className='flexRow ' >
          { deleteButton }
          { upButton }
          { downButton }
        </div>
        { widthMenu }
        { fontSizeMenu }
        { textPositionMenu }
        <div className='marginTop1' >
          { urlField }
        </div>
      </div>
    </div>
  );
}

export {
  PopupDisplay,
  EditPopupDisplayPopup,
  Note,
  NoteMenuSpPopup,
  ManageComponentPopup,
  AddComponentButton,
  CloseMenuButton,
  AddTextButton,
  AddImageButton,
  SaveNoteButton,
  PublishNoteButton,
  UnpublishNoteButton,
  DeleteNoteButton,
  ChangePublicationTypeButton,
};
